// Routes owned by the inventory module (HANDOFF §3 «/inventory/*», paths
// PROPOSED by the spec) and the links it makes into other modules.
//
//   «سند صرف» (supplier row) → the payment-voucher panel pre-filled with the
//       supplier: /accounts/vouchers?panel=payment-voucher&supplier_id=…
//       (same contract as accounts/payables' paymentVoucherHref).
//   «كشف حساب» (supplier row) → the ledger of account 2100 filtered by the
//       supplier: /accounts/ledger/:accountId?supplier_id=…
//   a move's invoice → /accounts/invoices/:id (accounts module).

export const INV = {
  root: '/inventory',
  items: '/inventory/items',
  newItem: '/inventory/items/new',
  item: (id: string) => `/inventory/items/${encodeURIComponent(id)}`,
  purchases: '/inventory/purchases',
  newPurchase: '/inventory/purchases/new',
  purchase: (id: string) => `/inventory/purchases/${encodeURIComponent(id)}`,
  suppliers: '/inventory/suppliers',
  counts: '/inventory/counts',
  count: (id: string) => `/inventory/counts/${encodeURIComponent(id)}`,
  moves: '/inventory/moves',
  movesOf: (itemId: string) => `/inventory/moves?item_id=${encodeURIComponent(itemId)}`,
} as const;

export function supplierPaymentHref(supplierId: string): string {
  const qs = new URLSearchParams({ panel: 'payment-voucher', supplier_id: supplierId });
  return `/accounts/vouchers?${qs.toString()}`;
}

export function supplierLedgerHref(accountId: string, supplierId: string): string {
  return `/accounts/ledger/${encodeURIComponent(accountId)}?supplier_id=${encodeURIComponent(supplierId)}`;
}

export function invoiceHref(id: string): string {
  return `/accounts/invoices/${encodeURIComponent(id)}`;
}

/** The supplier payables account (BRIEF standard COA). */
export const PAYABLES_ACCOUNT_CODE = '2100';
